<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AddressSelect',
})
</script>
<template>
  <TreeSelect
    v-model:value="valueTmp"
    v-bind="{ ...$attrs, ...(props.multiple ? multipleProps : {}) }"
    :tree-data="treeData"
    :treeLine="{ showLeafIcon: false }"
    treeDefaultExpandAll
    showSearch
    allowClear
    treeNodeFilterProp="stationName"
    placeholder="请选择"
  />
</template>

<script lang="ts" setup name="AddressSelect">
import { TreeSelect } from 'ant-design-vue'
import { computed } from 'vue'
import { normalizeTreeValue } from '@/utils/helper'
import { useDictStore } from '@/store/modules/dict'
const props = withDefaults(
  defineProps<{
    multiple?: boolean
    value?: string | string[]
  }>(),
  {
    multiple: false
  }
)
const emits = defineEmits<{
  (e: 'update:value', value: string | string[]): void
}>()
const valueTmp = computed({
  get() {
    return props.value
  },
  set(val) {
    if (props.multiple) {
      emits('update:value', normalizeTreeValue(val as any[]))
    } else {
      emits('update:value', val as string)
    }
  }
})

const multipleProps = {
  multiple: true,
  treeCheckable: true,
  showCheckedStrategy: 'SHOW_ALL',
  treeCheckStrictly: true
}
const dictStore = useDictStore()
const treeData = computed(() => dictStore.category.get('address') || [])
</script>
